import React, { memo, useCallback, useMemo } from 'react'

import { FiltersSidebar } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import { POPOVER_FEATURES } from 'Pods/SearchPage/Shared/FeaturesContent/constants'
import { getFeatureFilter } from 'Pods/SearchPage/Shared/Tracking/constants'
import { useTrackFilterSelect } from 'Pods/SearchPage/Shared/Tracking/FilterTracking'
import useTranslate from 'Pods/SearchPage/Shared/useTranslate'
import { ASSET_TYPE } from 'Pods/SearchPage/Store/constants'
import { useSearchPageStore } from 'Pods/SearchPage/Store/index'

import { EMPTY_ARRAY } from 'Utils/stableDefaults'

// Joined so zustand's strict equality holds across renders.
const selectActiveFeatures = state => POPOVER_FEATURES
  .filter(feature => feature.select(state))
  .map(feature => feature.value)
  .join(',')

function PopoverFeaturesContent() {
  const translate = useTranslate()
  const trackFilterSelect = useTrackFilterSelect()

  const is3DOnly = useSearchPageStore(state => state.assetType === ASSET_TYPE.THREE_D_ONLY)
  const activeKey = useSearchPageStore(selectActiveFeatures)
  const selectedFeatures = useMemo(() => (activeKey ? activeKey.split(',') : EMPTY_ARRAY), [activeKey])

  const config = useMemo(() => [{
    label: translate('search_page.filters.features.title'),
    filters: POPOVER_FEATURES.map(({ value, labelKey }) => ({
      value,
      label: translate(`search_page.filters.${labelKey}`),
    })),
  }], [translate])

  const handleChange = useCallback((_, value, isOn) => {
    const feature = POPOVER_FEATURES.find(item => item.value === value)
    if (!feature) return
    if (isOn) {
      const { name, value: filterValue } = getFeatureFilter(value)
      trackFilterSelect(name, filterValue)
    }
    feature.onChange(isOn)
  }, [trackFilterSelect])

  if (!is3DOnly) return null

  return (
    <FiltersSidebar
      isCollapsible={false}
      filters={config}
      selectedFilters={selectedFeatures}
      onFiltersChange={handleChange}
      isControlled
      useNewCheckboxes
      hideShowMore
      baseFormWrapperClassName="filter-wrapper__content"
    />
  )
}

export default memo(PopoverFeaturesContent)
